export default __webpack_public_path__ + "static/media/info-circle-full.d3657fab.svg";